import React from "react";

function About() {
  return (
    <>


     <div id="inner-hero" className="inner-hero bg-com pt-50 pb-50">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="inner-text text-center">
                        <div className="inner-title">About <span>Us</span></div>
                        <ul className="inner-link">
                            <li>Home</li>
                            <li>About Us</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>




      <section id="about-us" className="about-two pt-130 pb-50">
        <div className="container">
          <div className="row">

            <div className="col-lg-4">
              <div className="about-img">
                <img
                  src="/assets/img/amit-kumar.jpg"
                  alt="Amit Kumar"
                />

                <br />
                <br />

                <h3 className="text-center">Amit Kumar</h3>
                <h5 className="text-center">
                  Founder &amp; CMD 121 BBTC
                </h5>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="about-content">

                <div className="section-content">
                  <h3>About Us</h3>

                  <h2 className="section-title">
                    121 Bharat Business Tycoon Chamber
                  </h2>

                  <div className="section-border">
                    <span></span>
                  </div>
                </div>

                <div className="about-text">
                  <h3>Concept &amp; Vision</h3>

                     <ul class="home-three-about-list">
                                <li>Exclusive Business Club: Bharat Business Tycoon Chamber (BBTC) is an exclusive business relationship club of 
121 leading entrepreneurs and business leaders from across India. </li>
                                <li>Main objective: The platform is designed to foster investments, startups and growth opportunities as well as build a 
foundation for strong collaboration for national economic progress.</li>

                             <li>Founder's Vision: The entire concept of this Chamber has been envisioned by Amit Kumar, who has an impressive 
presence of 22 years in the media industry.</li>

<li>Founder's Expertise: Amit Kumar has studied and worked extensively in multiple domains such as real estate, 
wedding industry, and FMCG, bringing unmatched insights and expertise.</li>

<li>Ecosystem Building: The Chamber aims to create an ecosystem where new ideas take shape, enterprises are 
nurtured, and India emerges as a global business power</li>
                               
                                </ul>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      <section
        id="about-team-information"
        className="about-team-information-area pt-130 pb-130"
      >
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <div className="about-team-information-right row">

                <div className="col-md-3 col-sm-3">
                  <div className="about-team-information-item">
                    <div className="about-information-icon">
                      <img
                        src="/assets/img/teams-icon.png"
                        alt="A Great Team"
                      />
                    </div>

                    <h4>A Great Team</h4>
                  </div>
                </div>

                <div className="col-md-3 col-sm-3">
                  <div className="about-team-information-item">
                    <div className="about-information-icon">
                      <img
                        src="/assets/img/dedicated-icon.png"
                        alt="We Are Dedicated"
                      />
                    </div>

                    <h4>We Are Dedicated</h4>
                  </div>
                </div>

                <div className="col-md-3 col-sm-3">
                  <div className="about-team-information-item">
                    <div className="about-information-icon">
                      <img
                        src="/assets/img/support-icon.png"
                        alt="Life Time Support"
                      />
                    </div>

                    <h4>Life Time Support</h4>
                  </div>
                </div>

                <div className="col-md-3 col-sm-3">
                  <div className="about-team-information-item">
                    <div className="about-information-icon">
                      <img
                        src="/assets/img/dependable-team-icon.png"
                        alt="Dependable Team"
                      />
                    </div>

                    <h4>Dependable Team</h4>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default About;